import { render } from "./FooterAccount.vue?vue&type=template&id=ea3d7a5e"
import script from "./FooterAccount.vue?vue&type=script&lang=js"
export * from "./FooterAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__